var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "839C43AF-0990-4418-AF30-F1D14E7FEDE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products",
    transform: "translate(-540.000000, -195.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(502.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Xnix/Line/Edit",
    transform: "translate(39.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1999755,0.127582315 L13.765976,1.37458237 C13.9172109,1.51691352 14.0024642,1.71571347 14.0013376,1.92338837 C14.0001883,2.13106327 13.9127612,2.32891708 13.7599757,2.46958231 L12.5699757,3.89358239 L8.52097567,8.72258221 C8.45014942,8.80371091 8.35575592,8.86069651 8.25097556,8.88558231 L6.15097565,9.36158229 C5.87546533,9.37536577 5.63561208,9.1751259 5.5999756,8.9015824 L5.5999756,6.74358243 C5.60712343,6.63954599 5.64903444,6.54093197 5.7189756,6.46358244 L9.69297567,1.97058237 L11.0569758,0.341582306 C11.3268279,-0.0121376592 11.8204353,-0.104554112 12.1999755,0.127582315 Z",
    id: "Vector-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5330085,1.8685913 L3.73300849,1.8685913 C1.66674817,1.87355621 -0.00441466312,3.55232943 0,5.61859149 L0,11.2435915 C-0.00441466312,13.3098533 1.66674817,14.9886268 3.73300849,14.9935913 L9.33300812,14.9935913 C11.3992688,14.9886268 13.0704307,13.3098533 13.066017,11.2435915 L13.066017,7.49359132 M9.693008,1.9705913 C10.015008,2.75059128 11.041008,4.22759144 12.570008,3.8895913 M2.8000088,12.1815913 L10.2670088,12.1815913",
    id: "Vector-9"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b8a234f4b22aa568a5d3e32f4bf490c3.svg";
export { ForwardRef as ReactComponent };